export default {
    LOAD_NOTE(state, note) {
        state.items = note;
    }
}